import React, {
	memo
}from 'react'
import {
	useDispatch, useSelector
}from 'react-redux'
import {
	Skeleton, Tooltip, Row, Col
}from 'antd'
import { 
	resolutionsActions 
} from '../Resolutions/store/actions'
import i18n from './localization'
import SignedIcon from "../../../../public/signedIcon.png"

const ResolutionResultFiles = memo(({
	resolutionResultFiles, isRu, isSummaryResult, showSignerInfo
}) => {
	const {
		downloadResolutionFileLoading
	} = useSelector((state) => state.resolutionReducer)
	const dispatch = useDispatch()

	function getFile(id, fileName, fileExtension){
		if(id && !downloadResolutionFileLoading){
			dispatch(resolutionsActions.downloadResolutionFile({
				FileId : id,
				Type   : !isSummaryResult ? "intermediateFiles" : ""
			},{fileName, fileExtension}))
		}
	}

	return (
		<>
			{ resolutionResultFiles != null ? (
				resolutionResultFiles.length ? (
					<>
						<Row>
							<Col md={12}>
								{i18n.answerFiles[isRu]}
							</Col>
						</Row>
						<Row className='appealResultsList'>
							{ resolutionResultFiles.map((item) => {
								return (
									<div
										key={ `additionalOrderMessageFile_${ item.id }` }
										className="custom-file"
									>
										{item.signerInfo && showSignerInfo &&
											<Tooltip 
												title={i18n.signer[isRu].format(item.signerInfo)}
												overlayInnerStyle={{ whiteSpace: 'pre-line' }}
												className='signer_icon'
											>
												<img src={SignedIcon} width={20} height={20} style={{verticalAlign: "middle", marginRight: "3px"}}/>
											</Tooltip>
										}
										<Tooltip
											placement="left"
											title={ item.fileName + item.fileExtension }
										>
											<a onClick={ () => !downloadResolutionFileLoading && getFile(item.id, item.fileName, item.fileExtension) }>
												{ item.fileName + item.fileExtension }
											</a>
										</Tooltip>
									</div>
								)
							}) }
						</Row>
					</>
				) : null
			) : (
				<Skeleton
					active
					loading
				/>
			) }
		</>
	)
})

export default ResolutionResultFiles